import { useCallback, useEffect, useState } from 'react'

import {
  fetchAccountProfessionalSummaryVariants,
  type AccountSummaryVariant,
} from '../lib/accountProfessionalSummaryLibrary'
import { supabase } from '../lib/supabase'

export function useAccountProfessionalSummaryLibrary(resumeId: string | undefined) {
  const [variants, setVariants] = useState<AccountSummaryVariant[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refresh = useCallback(async () => {
    if (!resumeId) {
      setVariants([])
      setError(null)
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)
    try {
      const result = await fetchAccountProfessionalSummaryVariants(supabase, {
        currentResumeId: resumeId,
      })
      setVariants(result)
    } catch (err) {
      setVariants([])
      setError(err instanceof Error ? err.message : 'Failed to load summary variants')
    } finally {
      setLoading(false)
    }
  }, [resumeId])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return { variants, loading, error, refresh }
}
